import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  CircularProgress,
  Switch,
  FormControlLabel,
  Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { createCities } from "../../../../../services/Admin/ShippingCategoriesApi";

const emptyCity = { name_ar: "", name_en: "", status: true, shipping_category_id: "", governorate_id: "" };

const AddCitiesDialog = ({ open, onClose, onSuccess, governorates = [], categoryId }) => {
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([{ ...emptyCity }]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setCities([{ ...emptyCity, shipping_category_id: categoryId || "" }]);
      setError("");
    }
  }, [open, categoryId]);

  const handleAddCity = () => setCities([...cities, { ...emptyCity, shipping_category_id: categoryId || "" }]);
  const handleRemoveCity = (i) => setCities(cities.length > 1 ? cities.filter((_, idx) => idx !== i) : cities);
  const handleChange = (i, field, value) => {
    const arr = [...cities];
    arr[i][field] = value;
    setCities(arr);
  };

  const handleSubmit = async () => {
  setError("");

  const valid = cities.filter(c => (c.name_ar || c.name_en));

  if (!valid.length) {
    setError("يرجى إضافة مدينة واحدة على الأقل");
    return;
  }

  if (valid.some(c => !c.governorate_id)) {
    setError("يرجى اختيار المحافظة لكل مدينة");
    return;
  }

  const citiesPayload = valid.map(c => ({
    name_ar: c.name_ar.trim(),
    name_en: c.name_en.trim(),
    status: !!c.status,
    shipping_category_id: categoryId
      ? Number(categoryId)
      : (c.shipping_category_id ? Number(c.shipping_category_id) : null),
    governorate_id: Number(c.governorate_id),
  }));

  setLoading(true);
  try {
    const res = await createCities(citiesPayload); // ✅ Array
    if (res?.success) onSuccess?.();
    else setError(res?.message || "فشل إضافة المدن");
  } catch (err) {
    setError(err?.message || "حدث خطأ أثناء الإضافة");
  } finally {
    setLoading(false);
  }
};


  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>إضافة مدن</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Box>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="subtitle2">المدن</Typography>
              <Button size="small" startIcon={<AddIcon />} onClick={handleAddCity}>إضافة مدينة</Button>
            </Stack>

            <Stack spacing={2}>
              {cities.map((c, idx) => (
                <Paper key={idx} sx={{ p: 2 }} variant="outlined">
                  <Stack spacing={2}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <TextField label="الاسم بالعربية" value={c.name_ar} onChange={(e) => handleChange(idx, "name_ar", e.target.value)} size="small" fullWidth />
                      <TextField label="الاسم بالإنجليزية" value={c.name_en} onChange={(e) => handleChange(idx, "name_en", e.target.value)} size="small" fullWidth />
                      <IconButton color="error" onClick={() => handleRemoveCity(idx)} disabled={cities.length === 1}><DeleteIcon /></IconButton>
                    </Stack>

                    <Stack direction="row" spacing={2} alignItems="center">
                      <FormControl size="small" sx={{ minWidth: 220 }}>
                        <InputLabel>المحافظة</InputLabel>
                        <Select value={c.governorate_id} label="المحافظة" onChange={(e) => handleChange(idx, "governorate_id", e.target.value)}>
                          <MenuItem value="">اختر المحافظة</MenuItem>
                          {governorates.map(g => <MenuItem key={g.id} value={g.id}>{g.name_ar || g.name_en}</MenuItem>)}
                        </Select>
                      </FormControl>

                      <FormControlLabel
                        control={<Switch checked={c.status} onChange={(e) => handleChange(idx, "status", e.target.checked)} />}
                        label={c.status ? "مفعّل" : "معطّل"}
                      />
                    </Stack>
                  </Stack>
                </Paper>
              ))}
            </Stack>
          </Box>

          {error && <Typography color="error" variant="body2">{error}</Typography>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCitiesDialog;
